<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.slagIronPara')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/slagIronPara"><span>{{$t('tlt.slagIronPara')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('slagIronPara')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>

        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <mes-filter entity="slagIronPara" />
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="slagIronParaListTabel" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionResult">
                        <div class="card-body">
                            <mmf-table entity="slagIronPara" inline-actions-disabled singleChoice>
                                <div slot="btnList" class="btn-group">
                                    <button v-bind:class="'btn btn-outline-primary btn-sm'" v-on:click="jumpToDrillDepth()">
                                        <i class="fas fa-tasks"></i>
                                        <span class="text">{{$t('tlt.drillDepth')}}</span>
                                    </button>
                                </div>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import MmfTable from "@/components/MmfTable";
import MesFilter from '@/components/MesFilter'

// 常量
const moduleName = "slagIronPara";

export default {
  components: {
    MmfTable,
    MesFilter
  },
  methods: {
    ...mapActions(moduleName, ["jumpToEdit"]),
    ...mapActions("base", ["MMFLoadRows", "MMFNew"]),
    jumpToDrillDepth() {
        this.$router.push("/prd/drillDepth");
    },
  },
  data() {
    return {
      moduleName: moduleName
    };
  }
};
</script>